import script from "./CardFormBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFormBackground.vue?vue&type=script&setup=true&lang=js"

import "./CardFormBackground.vue?vue&type=style&index=0&id=49ed43de&lang=scss&scoped=true"

import exportComponent from "C:\\Frontend\\Projects\\interactive-card-details-form-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ed43de"]])

export default __exports__